import React, { Component } from 'react';
import PropTypes from "prop-types";

/**
 * Anonymous form layout. Use this layout to present a form before the user has
 * logged in.
 *
 * Used for: account registration/activation and password request.
 */
class AnonymousFormLayout extends Component {
  render() {
    const children = this.props.children;
    return (
      <div className="container">
        <div className="card o-hidden border-0 shadow-lg my-5">
          <div className="card-body p-0">
            <div className="row">
              <div className={"col-lg-5 d-none d-lg-block " + this.props.backgroundImageStyle}/>
              <div className="col-lg-7">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AnonymousFormLayout.propTypes = {
  backgroundImageStyle: PropTypes.string,
  children: PropTypes.element.isRequired
};

export default AnonymousFormLayout;